import {css} from '@emotion/react';
import styled from '@emotion/styled';

export const Container = styled.div(
  ({theme}) => css`
    position: relative;
    z-index: ${theme.stacking.zIndexControlsPriority};
    display: flex;
    justify-content: space-between;
    align-items: center;
    column-gap: 16px;
    min-height: 44px;
    padding: 4px 4px 4px 16px;
    background: ${theme.colors.backgroundTertiary};
  `
);
